<main id="content" role="main" class="main bgb-blue">
 
  <div class="container py-20 py-sm-7">
    <div class="mx-auto" style="max-width: 30rem;">
      <!-- Card -->
      <div class="card card-lg mb-5 py-20 py-sm-7">
        <a class="d-flex justify-content-center mb-2" routerLink="/">
          <img class="zi-2" src="../../../assets/images/DumyUser/touch.png" alt="Image Description" style="width: 8rem;">
        </a>
        <div class="card-body">
          <!-- Form -->
          <div class="js-validate needs-validation" novalidate>
            <div class="text-center">
              <div class="mb-5">
                <h1 class="display-5">Opps Account is Blocked</h1>
                <p>Opps your Account is Blocked By Administration .Please Contact Admin team to unblock it.</p>
              </div>
            </div>
            <div class="d-grid">
              <a routerLink="/contact" class="btn btn-primary px-5 rounded-4" >contact</a>
            </div>
          </div>
          <!-- End Form -->
        </div>
      </div>
      <!-- End Card -->

    
    </div>
  </div>
  
</main>

